import shoppalfoods from "../../Assets/Vendors/Shoppal foods/shop";
import shoppalgroceries from "../../Assets/Vendors/Shoppal groceries/shop";
import shoppalpharmacy from "../../Assets/Vendors/Shoppal pharmacy/shop";
import coldestwater from "../../Assets/Vendors/The Coldest Water/shop"
import chickenrepublic from "../../Assets/Vendors/Chicken Republic/shop"
import dominospizza from "../../Assets/Vendors/Dominos Pizza/shop"
import theplace from "../../Assets/Vendors/The Place/shop"
import burgerking from "../../Assets/Vendors/Burger King/shop"
import burgerkinglagos from "../../Assets/Vendors/Burger King Lagos/shop"
import burgerkingph from "../../Assets/Vendors/Burger King PH/shop"
import burgerkinguyo from "../../Assets/Vendors/Burger King uyo/shop"
import chickenrepubliclagos from "../../Assets/Vendors/Chicken Republic Uyo/shop"
import chickenrepublicph from "../../Assets/Vendors/Chicken Republic PH/shop"
import chickenrepublicuyo from "../../Assets/Vendors/Chicken Republic Uyo main/shop"
import dominospizzalagos from "../../Assets/Vendors/Dominos Pizza Lagos/shop"
import dominospizzaph from "../../Assets/Vendors/Dominos Pizza PH/shop"
import dominospizzauyo from "../../Assets/Vendors/Dominos Pizza Uyo/shop"
import theplacelagos from "../../Assets/Vendors/The Place Lagos/shop"
import theplaceph from "../../Assets/Vendors/The Place PH/shop"
import theplaceuyo from "../../Assets/Vendors/The Place Uyo/shop"
import coldestwaterlagos from "../../Assets/Vendors/The Coldest Water Lagos/shop"
import coldestwaterph from "../../Assets/Vendors/The Coldest Water PH/shop"
import coldestwateruyo from "../../Assets/Vendors/The Coldest Water Uyo/shop"

export const shops = [
  chickenrepublic,
  coldestwater,
  dominospizza,
  theplace,
  burgerking,
  burgerkinglagos,
  burgerkingph,
  burgerkinguyo,
  chickenrepubliclagos,
  chickenrepublicph,
  chickenrepublicuyo,
  dominospizzalagos,
  dominospizzaph,
  dominospizzauyo,
  theplacelagos,
  theplaceph,
  theplaceuyo,
  coldestwaterlagos,
  coldestwaterph,
  coldestwateruyo,
  /*shoppalfoods,
  shoppalgroceries,*/
];